<template>
  <div
    :id="anchorId"
    :class="b()"
    :style="styles"
  ></div>
</template>

<script lang="ts">
  import { defineComponent } from 'vue';

  // type Setup = {}
  // type Data = {}

  /**
   * Renders an invisible anchor tag for c-content-navigation.
   */
  export default defineComponent({
    name: 'c-content-section-anchor',

    // components: {},

    props: {
      /**
       * Define an offset.
       */
      offset: {
        type: Number,
        default: 0,
      },

      /**
       * The anchor id.
       */
      anchorId: {
        type: String,
        required: true,
      },
    },
    // emits: [],

    // setup(): Setup {
    //   return {};
    // },
    // data(): Data {
    //   return {};
    // },

    computed: {
      styles(): Record<string, string> {
        return {
          '--c-content-section-anchor-offset': `${this.offset}px`,
        };
      },
    },
    // watch: {},

    // beforeCreate() {},
    // created() {},
    // beforeMount() {},
    // mounted() {},
    // beforeUpdate() {},
    // updated() {},
    // activated() {},
    // deactivated() {},
    // beforeUnmount() {},
    // unmounted() {},

    // methods: {},
    // render() {},
  });
</script>

<style lang="scss">
  .c-content-section-anchor {
    display: block;
    position: relative;
    top: var(--c-content-section-anchor-offset);
    visibility: hidden;
    user-select: none;
  }
</style>
